"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var raf_1 = tslib_1.__importDefault(require("rc-util/lib/raf"));
var easings_1 = require("./easings");
var getScroll_1 = tslib_1.__importStar(require("./getScroll"));
function scrollTo(y, options) {
    if (options === void 0) { options = {}; }
    var _a = options.getContainer, getContainer = _a === void 0 ? function () { return window; } : _a, callback = options.callback, _b = options.duration, duration = _b === void 0 ? 450 : _b;
    var container = getContainer();
    var scrollTop = (0, getScroll_1.default)(container, true);
    var startTime = Date.now();
    var frameFunc = function () {
        var timestamp = Date.now();
        var time = timestamp - startTime;
        var nextScrollTop = (0, easings_1.easeInOutCubic)(time > duration ? duration : time, scrollTop, y, duration);
        if ((0, getScroll_1.isWindow)(container)) {
            container.scrollTo(window.pageXOffset, nextScrollTop);
        }
        else if (container instanceof HTMLDocument || container.constructor.name === 'HTMLDocument') {
            container.documentElement.scrollTop = nextScrollTop;
        }
        else {
            container.scrollTop = nextScrollTop;
        }
        if (time < duration) {
            (0, raf_1.default)(frameFunc);
        }
        else if (typeof callback === 'function') {
            callback();
        }
    };
    (0, raf_1.default)(frameFunc);
}
exports.default = scrollTo;
//# sourceMappingURL=scrollTo.js.map